import { oz } from '@weft/utils';
import { CreditProductConfigurationSchema } from './credit/credit-product-configuration';
import { ServiceProductConfigurationSchema } from './service/service-product-configuration';

export const ProductConfigurationSchema = oz.union([
  CreditProductConfigurationSchema,
  ServiceProductConfigurationSchema,
]).openapi('ProductConfiguration');

export type ProductConfiguration = oz.infer<typeof ProductConfigurationSchema>;